import { put } from "redux-saga/effects";
import { ProductivityReportAction } from "../../action";
import { Client } from "../../../../utils/transport";
import { hms, hmsOnlyNumber } from "utils/timeConverter";
import dayjs from "dayjs";
import { ExportCSV } from "utils/export-csv";
import offlineValue from "utils/getOfflineTime";
import calculatePercentage from "utils/func_percentage";
import { getDownloadTableViewColumns } from "utils/commonUtils";

const ExportData = (
  fileName,
  data,
  finalHeaders,
  filterDate,
  teams,
  payload
) => {
  let result = [];
  const Generated = "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");
  const generatedData = [
    fileName,
    teams.length > 0
      ? "Teams: - " + teams.join(",").replaceAll(",", "/")
      : "Teams: - " + "All Teams",
    "Date:-" + filterDate,

    Generated,
    finalHeaders.join(),
  ];

  data.forEach((record) => {
    const user = payload.usersList?.[record.identity_id];
    const employeeName =
      !record?.first_name && !record?.last_name
        ? "--"
        : `${record.first_name} ${record.last_name}`;

    const dynamicValues = getDownloadTableViewColumns(
      payload.viewFields,
      user,
      payload.teamMapData
    );

    const fixedValues = [
      record?.present,
      hmsOnlyNumber(record.online_duration),
      hmsOnlyNumber(record?.active_duration),
      hmsOnlyNumber(record?.idle_duration),
      hmsOnlyNumber(record.productive_duration),
      hmsOnlyNumber(record.unproductive_duration),
      hmsOnlyNumber(record.neutral_duration),
      hmsOnlyNumber(record.break_duration),
      !record?.productivity_percentage
        ? "0%"
        : record?.productivity_percentage + "%",
    ];
    generatedData.push(
      [employeeName, ...dynamicValues, ...fixedValues].join(",")
    );
  });
  result = generatedData;
  return result;
};

const getDownloadCSV = (payload, data) => {
  const teamIds = payload.bodyData.group_id.split(",");
  const selectTeamNames = payload.teamList
    .filter((item) => teamIds.includes(item.id))
    .map((item) => item.name);

  const csvdata = data?.data;
  const sortData = csvdata.sort((a, b) =>
    a.first_name.localeCompare(b.first_name)
  );

  const date =
    dayjs(payload?.bodyData?.start_date).format("YYYY-MM-DD") +
    " To " +
    dayjs(payload?.bodyData?.end_date).format("YYYY-MM-DD");

  // Dynamic columns
  const dynamicFields = payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = [
    "Attendance",
    "Online time (hh:mm:ss)",
    "Active time (hh:mm:ss)",
    "Idle time (hh:mm:ss)",
    "Productive time (hh:mm:ss)",
    "Unproductive time (hh:mm:ss)",
    "Neutral time (hh:mm:ss)",
    "Break time (hh:mm:ss)",
    "Productivity %",
  ];

  const finalHeaders = [
    "Employee", // full name
    ...dynamicHeaders,
    ...fixedHeaders,
  ];
  const exdata = ExportData(
    "Productivity Employee List",
    sortData,
    finalHeaders,
    date,
    selectTeamNames,
    payload
  );

  ExportCSV("Productivity_Employee_List_", exdata);
};

export function* GetProductivityReportData(data) {
  const config = {
    method: "POST",
    url: "query/productivity/productivity_employee_list",

    headers: {
      Authorization: `Bearer ` + data.token,
    },
    data: data.bodyData,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);

    if (response.status === 200) {
      yield put(
        ProductivityReportAction.ProductivityReportSuccess(response.data)
      );
    } else {
      yield put(ProductivityReportAction.ProductivityReportFailed(response));
    }
  } catch (err) {
    yield put(ProductivityReportAction.ProductivityReportFailed(err));
  }
}

export function* GetProductivityDownloadReportData(data) {
  const config = {
    method: "POST",
    url: "query/productivity/productivity_employee_list",

    headers: {
      Authorization: `Bearer ` + data.token,
    },
    data: data.bodyData,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);

    if (response.status === 200) {
      getDownloadCSV(data, response.data);
      yield put(ProductivityReportAction.ReportDownloadProductivitySuccess());
    } else {
      yield put(
        ProductivityReportAction.ReportDownloadProductivityFailed(response)
      );
    }
  } catch (err) {
    yield put(ProductivityReportAction.ReportDownloadProductivityFailed(err));
  }
}
1;
